import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=fdb4cdf2&scoped=true&"
import script from "./chat.js?vue&type=script&lang=js&"
export * from "./chat.js?vue&type=script&lang=js&"
import style0 from "./chat.scss?vue&type=style&index=0&id=fdb4cdf2&prod&lang=scss&scoped=true&"
import style1 from "./global.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb4cdf2",
  null
  
)

export default component.exports